import { Currency } from 'noddi-types';

const FORMATTER_STYLE = 'currency';

enum Locales {
  NOK = 'no-NO',
  SEK = 'sv-SE'
}
function getCurrencyLocales(currency: Currency) {
  switch (currency) {
    case Currency.NOK:
      return Locales.NOK;
    case Currency.SEK:
      return Locales.SEK;
  }
}

type MoneyWithOptionalCurrency = {
  amount: number;
  currency?: Currency;
};

export const formatCurrencyAmount = ({
  money: { amount, currency = Currency.NOK },
  decimals = 2
}: {
  money: MoneyWithOptionalCurrency;
  decimals?: 0 | 2;
}) => {
  const currencyLocales = getCurrencyLocales(currency);

  const currencyFormatter = new Intl.NumberFormat(currencyLocales, {
    style: FORMATTER_STYLE,
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

  return currencyFormatter.format(amount);
};
